import { Injectable } from '@angular/core';

export interface UtilityApp {
  icon: string;
  title: string;
  subtitle: string;
  route: string;
}

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  utilities: UtilityApp[] = [
    { icon: 'domain_add', title: 'SSO Domain Management', subtitle: 'View and create single sign-on domains', route: 'sso-domain-management' },
  ];

  constructor() { }
}
